import { api_get_scrapers, api_attach_scraper, api_update_scraper, api_detach_scraper, api_trigger_scraper_run, api_get_scraper_run } from '../../../queries/scrapers';

export const scrapersStoreActions = self => ({
  set(key, value) {
    self[key] = value;
  },

  async loadScrapers() {
    self.set('loading', true);
    try {
      const res = await api_get_scrapers(self.token);
      if (res && res.data) {
        self.set('scrapers', res.data.data ?? []);
        self.set('providers', res.data.providers ?? []);
        self.set('service', res.data.service ?? null);
      }
    } catch (error) {
      console.error('Failed to load scrapers', error);
    } finally {
      self.set('loading', false);
    }
  },

  async attachScraper(merchantId, payload) {
    self.set('updating', true);
    try {
      const res = await api_attach_scraper(merchantId, payload, self.token);
      await self.loadScrapers();
      return res?.data;
    } catch (error) {
      console.error('Failed to attach scraper', error);
      throw error;
    } finally {
      self.set('updating', false);
    }
  },

  async updateScraper(integrationId, payload) {
    self.set('updating', true);
    try {
      const res = await api_update_scraper(integrationId, payload, self.token);
      await self.loadScrapers();
      return res?.data;
    } catch (error) {
      console.error('Failed to update scraper', error);
      throw error;
    } finally {
      self.set('updating', false);
    }
  },

  /**
   * Queue a scrape and poll it until it finishes, so the modal can render
   * logs as they stream in. Polling (rather than SSE/websockets) keeps this
   * working through the existing auth and hosting with no new infrastructure.
   */
  async startScraperRun(integrationId) {
    self.set('runningIntegrationId', integrationId);
    self.set('activeRun', null);
    try {
      const res = await api_trigger_scraper_run(integrationId, self.token);
      const run = res?.data?.data;
      self.set('activeRun', run ?? null);
      if (run) self.pollScraperRun(run.id);
      return run;
    } catch (error) {
      self.set('runningIntegrationId', null);
      throw error;
    }
  },

  async pollScraperRun(runId) {
    const terminal = ['SUCCEEDED', 'FAILED'];
    for (let attempt = 0; attempt < 600; attempt++) {
      await new Promise(resolve => setTimeout(resolve, 1500));
      try {
        const res = await api_get_scraper_run(runId, self.token);
        const run = res?.data?.data;
        if (!run) continue;
        self.set('activeRun', run);
        if (terminal.includes(run.status)) {
          self.set('runningIntegrationId', null);
          self.loadScrapers();
          return run;
        }
      } catch (error) {
        console.error('Polling scrape run failed', error);
      }
    }
    self.set('runningIntegrationId', null);
  },

  clearScraperRun() {
    self.set('activeRun', null);
    self.set('runningIntegrationId', null);
  },

  async detachScraper(integrationId) {
    self.set('updating', true);
    try {
      const res = await api_detach_scraper(integrationId, self.token);
      await self.loadScrapers();
      return res?.data;
    } catch (error) {
      console.error('Failed to detach scraper', error);
      throw error;
    } finally {
      self.set('updating', false);
    }
  }
});
